<template>
    <button
        :type="type"
        class="focus:shadow-outline-gray rounded-md bg-iron-800 px-4 py-2 text-xs font-semibold tracking-widest text-white ease-in-out hover:bg-iron-700 focus:border-iron-900 active:bg-iron-900 inline-flex items-center border border-transparent uppercase transition duration-150 focus:outline-none disabled:opacity-25"
    >
        <slot></slot>
    </button>
</template>

<script lang="ts">
export default {
    props: {
        type: {
            type: String,
            default: "submit",
        },
    },
};
</script>
